import { useHistory, useLocation } from 'react-router'
import { useCallback, useEffect, useMemo, useState } from 'react'
import queryString from 'query-string'
import { OrderFilterId } from 'types/order'
import { UserRole } from 'types/user'

export const useOrderListFilterLocation = (userRole: UserRole) => {
  const location = useLocation()
  const history = useHistory()
  const queryObject = useMemo(() => queryString.parse(location.search), [location])
  const filterValue = useMemo(() => {
    const rawFilter = Array.isArray(queryObject.filter) ? queryObject.filter[0] : queryObject.filter
    return rawFilter === 'lenta' ? OrderFilterId.FEED : rawFilter
  }, [queryObject.filter])

  const defaultFilter = userRole === UserRole.CUSTOMER ? OrderFilterId.FEED : OrderFilterId.USER_ORDERS
  const [filter, setFilter] = useState<string>(filterValue || defaultFilter)

  useEffect(() => {
    setFilter(filterValue || defaultFilter)
  }, [defaultFilter, filterValue])

  const get = useCallback(() => {
    return filter
  }, [filter])

  const set = useCallback(
    (value: string) => {
      setFilter(value)
      const searchParams = new URLSearchParams(history.location.search)
      searchParams.set('filter', value.trim())
      searchParams.set('page', '1')

      history.push({ search: searchParams.toString() })
    },
    [history],
  )

  return useMemo(() => ({ get, set }), [get, set])
}
